import { Flex } from 'antd';

import NumberElement from 'components/number/number';
import Riyal from 'components/riyal/riyal';

interface RiyalIconProps {
	value: number;
	decimalScale?: number;
	color?: string;
	fontSize?: number | string;
	riyalSize?: number | string;
	fontStyle?: React.CSSProperties;
	containerStyle?: React.CSSProperties;
}

function PriceElement({ color, riyalSize = 15, value, decimalScale, fontSize, fontStyle, containerStyle }: RiyalIconProps) {
	return (
		<Flex style={{ display: 'inline-flex', direction: 'ltr', ...containerStyle }} align="center" gap={5}>
			<Riyal size={riyalSize} color={color} />
			<NumberElement value={value} decimalScale={decimalScale} style={{ color, fontSize, ...fontStyle }} />
		</Flex>
	);
}

export default PriceElement;
